const updates = [
  {
    date: '07-30',
    time: '14:32',
    tag: '最新',
    content: '某知名品牌代言人突然解约，官方声明称"双方和平分手"，粉丝圈炸锅。',
  },
  {
    date: '07-30',
    time: '11:15',
    tag: '热门',
    content: '热门综艺最新一期收视率再创新高，话题讨论度突破3亿。',
  },
  {
    date: '07-30',
    time: '09:08',
    tag: '快讯',
    content: '网红圈再爆大瓜：知名美食博主被曝后厨卫生问题，视频全网疯传。',
  },
  {
    date: '07-29',
    time: '22:45',
    tag: '更新',
    content: '吃瓜大赛半决赛结果出炉，黑马选手逆袭引全场欢呼。',
  },
  {
    date: '07-29',
    time: '18:20',
    tag: '热门',
    content: '娱乐圈某夫妻被拍到街头争吵，婚姻状况再度引发关注。',
  },
  {
    date: '07-29',
    time: '14:55',
    tag: '快讯',
    content: '新剧发布会现场突发状况，主演因身体不适提前离场。',
  },
  {
    date: '07-29',
    time: '10:30',
    tag: '更新',
    content: '平台发布最新公告：近期将严厉打击虚假吃瓜内容，维护社区环境。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            ⚡ 吃瓜快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时追踪全网动态，不错过任何一个瓜
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pb-8 last:pb-0">
                <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                  <span className="w-2.5 h-2.5 rounded-full bg-white"></span>
                </div>
                <div className="flex-1 pt-1.5">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {item.date} {item.time}
                    </span>
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}